import { forwardRef } from "react";
import { useReducedMotion } from "motion/react";
import * as m from "motion/react-m";
import { motionTokens } from "./tokens";
import { useLandingViewport } from "./useLandingMobile";

const createRevealVariants = ({ delay, distance, duration }) => ({
  hidden: {
    opacity: 0,
    y: distance,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      delay,
      duration,
      ease: motionTokens.easing.entrance,
    },
  },
});
export const Reveal = forwardRef(function Reveal(
  {
    as = "div",
    amount,
    children,
    delay = 0,
    distance = motionTokens.distance.standard,
    duration = motionTokens.duration.reveal,
    margin,
    ...props
  },
  ref,
) {
  const shouldReduceMotion = useReducedMotion();
  const defaultViewport = useLandingViewport();
  const resolvedAmount = amount ?? defaultViewport.amount;
  const resolvedMargin = margin ?? defaultViewport.margin;
  const StaticElement = as;

  if (shouldReduceMotion) {
    return <StaticElement ref={ref} {...props}>{children}</StaticElement>;
  }

  const MotionElement = m[as] || m.div;

  return (
    <MotionElement
      ref={ref}
      initial="hidden"
      whileInView="visible"
      viewport={{ amount: resolvedAmount, margin: resolvedMargin, once: true }}
      variants={createRevealVariants({ delay, distance, duration })}
      {...props}
    >
      {children}
    </MotionElement>
  );
});
